// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"0938fc6d621f737c","888":"f0ce9ce28ff7f2d4"}[chunkId] + ".css";
};